export default "__VITE_ASSET__28ca2baf__"